/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_notifications_emptymessage_all1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림이 없습니다`)
};

const en_notifications_emptymessage_all1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notifications`)
};

const ja_notifications_emptymessage_all1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知はありません`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const notifications_emptymessage_all1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.notifications_emptymessage_all1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("notifications_emptymessage_all1", locale)
	if (locale === "ko") return ko_notifications_emptymessage_all1(inputs)
	if (locale === "en") return en_notifications_emptymessage_all1(inputs)
	return ja_notifications_emptymessage_all1(inputs)
};
export { notifications_emptymessage_all1 as "notifications_emptyMessage_all" }